import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { retry, catchError, distinctUntilChanged, tap } from 'rxjs/operators';
import { QnASearchResultViewModel, QuestionAndAnswer, SCREEN_SIZE } from '../Models/common.model';

@Injectable({
    providedIn: 'root'
})

export class QnASearchService {

    private apiURL = window.location.origin;

    get onResize$(): Observable<SCREEN_SIZE> {
        return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
    }

    private resizeSubject: Subject<SCREEN_SIZE>;

    onResize(size: SCREEN_SIZE) {
        this.resizeSubject.next(size);
    }

    constructor(private http: HttpClient) {
        this.resizeSubject = new Subject();
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    }

    headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    });

    private _refreshQnA$ = new Subject<void>();
    get refreshQnA() {
        return this._refreshQnA$;
    }

    getSearchResults(currentPageId, page, pagesize, keywords, filter, statuses, GetQnAFor): Observable<QnASearchResultViewModel<QuestionAndAnswer>> {

        var queryParameters = "";
        if (currentPageId != null)
            queryParameters += 'currentPageId=' + currentPageId + '&';
        if (page != null)
            queryParameters += 'page=' + page + '&';
        if (pagesize != null)
            queryParameters += 'pageSize=' + pagesize + '&';
        if (keywords != null)
            queryParameters += 'searchKeyword=' + keywords + '&';
        if (filter != null)
            queryParameters += 'filteredBy=' + filter + '&';
        if (statuses != null)
            queryParameters += 'statuses=' + statuses.join(',') + '&';
        if (GetQnAFor != null)
            queryParameters += 'GetQnAFor=' + GetQnAFor + '&';

        queryParameters = queryParameters.slice(0, -1);
        
        return this.http.get<QnASearchResultViewModel<QuestionAndAnswer>>(this.apiURL + '/TocTabPageQnAViewAllBlock/SearchQuestions/?' + queryParameters)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    postAnswers(qna): Observable<boolean> {
        return this.http.post<boolean>(this.apiURL + '/TocTabPageQnAViewAllBlock/PostAnswers/', JSON.stringify(qna), this.httpOptions)
            .pipe(
                tap(() => {
                    this._refreshQnA$.next();
                }),
                retry(1),
                catchError(this.handleError)
            )
    }

    editQuestion(qna: any): Observable<boolean> {
        return this.http.post<boolean>(this.apiURL + '/TocTabPageQnAViewAllBlock/EditQuestion/', JSON.stringify(qna), this.httpOptions)
            .pipe(
                tap(() => {
                    this._refreshQnA$.next();
                }),
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteQuestion(qna): Observable<boolean> {
        return this.http.get<boolean>(this.apiURL + '/TocTabPageQnAViewAllBlock/DeleteQuestion/?' + 'questionId='+qna)
            .pipe(
                tap(() => {
                    this._refreshQnA$.next();
                }),
                retry(1),
                catchError(this.handleError)
            )
    }

    changePinStatus(questionId, pinStatus): Observable<boolean> {
        return this.http.get<boolean>(this.apiURL + '/TocTabPageQnAViewAllBlock/UpdatePinStatus/?' + 'questionId=' + questionId + '&' + 'pinStatus=' + pinStatus)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
